import Model from '@/shared/models/ResellerType'

export default class ResellerType extends Model {}
